namespace Vit.Administration {
    export interface TenantRoleForm {
        Id: Serenity.StringEditor;
        UserId: Serenity.StringEditor;
        TenantId: Serenity.LookupEditor;
        RoleId: Serenity.LookupEditor;
    }

    export class TenantRoleForm extends Serenity.PrefixedContext {
        static formKey = 'Administration.TenantRole';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!TenantRoleForm.init) {
                TenantRoleForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.LookupEditor;
                var w2 = s.LookupEditor;

                Q.initFormType(UserForm, [
                    'User',w0,
                    'Tenant', w1,
                    'Role', w2,
                ]);
            }
        }
    }
}
